import React, { Fragment } from 'react'
import Fade from 'react-reveal/Fade';
import NogmPdf from './NogmPdf';

function NogmBanner() {
    return (
        <Fragment>
            <div className='container governancemain motor' >
                <div className='row arrticleAndBlogs'>
                    <div className='col-sm-12 heads govbanner govbannerNOGM'>
                        <Fade up delay={500}><h2 className="oswald">Notice of General Meeting</h2></Fade>
                    </div>
                    <div className='col-sm-12 heads text mymaxheight'>
                      <NogmPdf/>
                    </div>                
                </div>
            </div>
        </Fragment>
    )
}

export default NogmBanner